var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EnhancedQSelect',{staticClass:"q-ml-sm",attrs:{"value":_vm.year,"options":_vm.years || [],"loading":!_vm.years,"label":"Start year of subscription period","dense":""},on:{"input":_vm.yearChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }